import './subscription.scss'
import {getPropsFromState} from "../../redux/mapStateToProps";
import {ChangeLanguage,AddSubscribers} from "../../redux/actions";
import {connect} from "react-redux";
import {InputGroup} from "../ui-elements/input-group/inputGroup";
import {FooterVector, SubClearIcon, SubscriptionBlockIcon, SubscriptionIcon} from "../../assets/images";
import {isEmail} from "validator";
import {useLocation} from "react-router-dom";
import {useEffect,useState} from "react";

function Subscription(props) {
    const {requestLoading,contact, staticTexts} = props
    const [email, setEmail] = useState('')
    const [errorEmail, setErrorEmail] = useState(false)
    const [openMs, setOpenMs] = useState(false)
    const location = useLocation();


    useEffect(()=>{
        setErrorEmail(false)
        setEmail('')
    },[location.pathname])

    const showTick = () => {
        setTimeout(
            () => {
                setEmail("")
                setErrorEmail(false)
            },
            2000,
        )

    }

    useEffect(() => {
        if(openMs){
            setTimeout(() => {
                setOpenMs(false)
            },1500)
        }
    }, [openMs])

    function getInputValues(e) {
        setErrorEmail(false)
        const {value} = e.target;
        setEmail(value)
    }

    function addSubscribers() {
        if (email && isEmail(email)) {
            props.AddSubscribers({email: email}).then(() => {
                setEmail(email)
                setOpenMs(true)
                showTick()
            }).catch((err) => {
                if(err.response?.data?.status){
                    setErrorEmail(true)
                }
            })
        } else {
            setErrorEmail(true)
        }
    }

    return <div className={'subscription-wrapper'}>
        <div className={'subscription-block'}>
            {
                openMs && <div className={'subscribe_msg'}>
                    {staticTexts?.homepage_subscription_ms}
                </div>
            }
            <div className={'subscription_left_block'}>
                <div className={'left_block_title'}>
                    <span>{staticTexts?.subscription_title}</span>
                    <span>{staticTexts?.subscription_description}</span>
                </div>
                <div className={`subscribeBlock ${errorEmail ? 'invalid' : ''}`}>
                    <InputGroup
                        inputType={'input'}
                        type={"text"}
                        // label={staticTexts?.homepage_contact_placeholder_email}
                        value={email}
                        // error={errorEmail}
                        name={'email'}
                        placeholder={staticTexts?.homepage_contact_placeholder_email}
                        maxLength={100}
                        onChange={getInputValues}
                    />
                    {
                        email && <div className={'subClear'} onClick={() => setEmail('')}>
                            <SubClearIcon/>
                        </div>
                    }
                    <button className={'subscribeBtn'}
                            onClick={() => {
                                if (!requestLoading && addSubscribers) {
                                    addSubscribers();
                                }
                            }}
                    >
                        <SubscriptionIcon/>
                    </button>
                </div>
            </div>
            <div className={'subscription_right_block'}>
                <a href={`mailto:${contact?.email}`}>
                    <p>@</p>
                </a>
                {/*<p>*/}
                {/*    <SubscriptionBlockIcon/>*/}
                {/*</p>*/}
            </div>
        </div>
    </div>

}

const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'languages',
        'staticTexts',
        'contact',
        'selectedLanguage',
    ])
};

const mapDispatchToProps = {
    ChangeLanguage,
    AddSubscribers
};

export default connect(mapStateToProps, mapDispatchToProps)(Subscription);
